<script>
import api from '@/command/api'
import DetailFormGroup from '../../../components/DetailFormGroup'
import moment from 'moment'
export default {
  name: 'freightCouponDetail',
  data() {
    return {
      ...api.command.getState(),
      // 店铺搜索
      storeData: [],
      detail: {}
    }
  },
  mounted() {
    const { id } = this.$route.query
    id &&
      api.command.getDetail
        .call(this, {
          url: `/freightCoupon/detail?id=${id}`
        })
        .then(result => {
          this.detail.shopIds = result.shopList.length ? result.shopList.map(e => e.shopId) : []
          this.$forceUpdate()
        })
    this.storeSearch()
  },
  methods: {
    getForm1() {
      return {
        title: '基本信息',
        type: 'cardForm',
        data: [
          {
            name: '券名(12字符内)',
            type: 'input',
            cols: 12,
            key: 'name',
            props: {
              maxLength: 12
            },
            rules: [
              {
                required: true,
                type: 'string'
              }
            ]
          },
          {
            name: '开始结束时间',
            type: 'rangePicker',
            cols: 12,
            keys: ['useStartTime', 'useEndTime'],
            rules: [
              {
                required: true,
                message: '请选择开始结束时间'
              }
            ]
          },
          {
            name: '优惠券出资人',
            cols: 12,
            rules: [
              {
                required: true
              }
            ],
            type: 'radioButton',
            key: 'couponSource',
            typeData: [
              {
                name: '平台',
                value: '1'
              },
              {
                name: '商家',
                value: '2'
              }
            ],
            display: true
          }
        ]
      }
    },
    async storeSearch(value = '') {
      let searchResult = await api.command.search.call(this, {
        url: `/api/commodity/farmMainBody/list?mainBodyName=${value}`
      })
      this.storeData = searchResult.map(el => {
        return {
          name: el.mainBodyName,
          value: el.id
        }
      })
    },
    getForm3() {
      return {
        title: '使用对象',
        type: 'cardForm',
        data: [
          {
            name: '券针对商家',
            cols: 4,
            rules: [
              {
                required: true
              }
            ],
            type: 'radioButton',
            key: 'shopType',
            typeData: [
              {
                name: '所有商家',
                value: '0'
              },
              {
                name: '指定商家',
                value: '1'
              }
            ],
            display: true
          },
          {
            name: '选择店铺',
            type: 'dropDownMultiInput',
            cols: 12,
            key: 'mainBodyName',
            onInputSearch: this.storeSearch,
            typeData: this.storeData,
            valueKey: 'shopIds',
            inputProps: {
              addonBefore: <a-icon type="search" />
            },
            display: this.detail.shopType == '1'
          }
        ].filter(e => e.display)
      }
    },
    getFoot() {
      const left = [
        {
          name: '提交',
          type: 'primary',
          loading: this.loading,
          sumbit: true,
          onClick: data => {
            if (data.useEndTime && data.useStartTime) {
              data.useEndTime = `${moment(data.useEndTime, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss')}`
              data.useStartTime = `${moment(data.useStartTime).format('YYYY-MM-DD HH:mm:ss')}`
            } else {
              this.$message.error('请选择开始结束时间！')
              return
            }
            let shopList = []
            data.shopIds &&
              data.shopIds.forEach(e => {
                shopList.push({ shopId: e })
              })
            api.command[data.id ? 'edit' : 'create']
              .call(this, {
                url: `/freightCoupon`,
                params: {
                  ...data,
                  shopList: shopList
                },
                isPost: false
              })
              .then(result => {
                this.$router.push('/marketingCenter/freightCoupon')
              })
          }
        },
        {
          name: '取消',
          type: 'default',
          onClick: () => this.$router.push('/marketingCenter/freightCoupon')
        }
      ]
      const right = [
        {
          name: '删除',
          popTitle: '确认删除吗?',
          isPop: true,
          type: 'danger',
          ghost: true,
          onClick: () => {
            api.command.delPut.call(this, {
              url: `/base/farmCouponRule/del?ids=${this.detail.id}`,
              isPost: false
            })
            setTimeout(() => {
              this.$router.push('/marketingCenter/freightCoupon')
            }, 500)
          }
        }
      ]
      return {
        left,
        right: this.detail.id && right
      }
    }
  },
  render() {
    return <DetailFormGroup form={this.detail} foot={this.getFoot()} data={[this.getForm1(), this.getForm3()]} />
  }
}
</script>
<style lang="less" scoped>
.entityInformation-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
}
</style>
